<template>
	<div class="pa-2">
		<v-row
			dense
			class="mb-3">
			<v-col cols="2">
				<v-text-field
					dense
					outlined
					:label="$T('inputs.name')"
					hide-details></v-text-field>
			</v-col>
			<v-col cols="2">
				<bee-date-picker
					:input-label="$T('inputs.date')"
					:input-props="{ outlined: true, dense: true, prependInnerIcon: '$calendar' }"
					:months-over-max="5"
					menu-picker
					calendar
					no-title
					hide-details></bee-date-picker>
			</v-col>
		</v-row>

		<v-card class="pa-4">
			<v-row
				dense
				justify="space-around">
				<v-col
					cols="2"
					class="font-weight-bold mb-3">
					عناصر التقييم
				</v-col>
				<v-col
					cols="3"
					class="font-weight-bold text-center"
					>مدير الموارد البشرية</v-col
				>
				<v-col
					cols="3"
					class="font-weight-bold text-center"
					>المسؤول المباشر</v-col
				>
				<v-col
					cols="3"
					class="font-weight-bold text-center"
					>المدير المسؤول</v-col
				>

				<template v-for="(item, i) in items">
					<v-col
						cols="2"
						:key="i + 'name'"
						class="font-weight-bold">
						{{ item }}
					</v-col>
					<v-col
						cols="3"
						v-for="j in 3"
						:key="i + '-' + j">
						<v-text-field
							dense
							outlined
							hide-details></v-text-field>
					</v-col>
				</template>
			</v-row>
		</v-card>
	</div>
</template>

<script>
export default {
	name: 'InterviewRanking',

	data() {
		return {
			items: [
				'الانطباع الاول',
				'المطهر الخارجي',
				'قوة الشخصية',
				'المؤهلات العلمية',
				'الخبرات العملية',
				'الدورات التدريبية',
				'القدرة على المحادثة',
			],
		};
	},
};
</script>

<style lang="scss" scoped></style>
